import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, of, tap } from 'rxjs';
import { AgentsService } from '../../orval-gen/endpoints/agents/agents.service';
import { AuthService } from '../shared/services/auth.service';
import { LocalStorageService } from '../shared/services/local-storage.service';
import { unwrap } from '../utils/http-utils';

let infoLoaded = false;

export const authGuard: CanActivateFn = (route, state) => {
  const agentsService = inject(AgentsService);
  const lsService = inject(LocalStorageService);
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);
  const router = inject(Router);

  if (infoLoaded) {
    const role = lsService.getItem('role');
    if (role !== 'manager' && role !== 'subagency_manager') {
      router.navigate(['/']);
      return of(false);
    }
    return of(true);
  }

  return agentsService.agencySession().pipe(
    unwrap(),
    tap(session => {
      infoLoaded = true;

      lsService.setItem('role', session.role);
      lsService.setBool('isConsumerOwner', session.consumer_owner);
      lsService.setItem('email', session.email);
      lsService.setBool('agencyStatus', session.agency.active);
      lsService.setBool('isSuperagency', session.agency.superagency);
      // Sent back as the AG-Agency header by the auth interceptor, so the hub scopes every call to this agency.
      lsService.setItem('agency', session.agency.name);
      lsService.setItem('agencyID', session.agency.id);
    }),
    map(session => {
      authService.isUserDataReceived.next(true);
      if (session.role !== 'manager' && session.role !== 'subagency_manager') {
        toastr.warning('Access denied: Only agency managers are allowed.', 'Unauthorized Role', {
          timeOut: 0,
          extendedTimeOut: 0,
          tapToDismiss: false,
        });
        router.navigate(['/']);
        return false;
      }
      return true;
    }),
    catchError(err => {
      console.error('Failed to load the session', err);
      lsService.clear();
      authService.isUserDataReceived.next(false);
      return of(true);
    })
  );
};
